import React, { useContext, useState } from "react";
import { withJsonFormsControlProps } from "@jsonforms/react";
import Input from "@salesforce/design-system-react/components/input";
import {
  setEditedValueinOption,
  getEditedValueFromOption,
} from "services/data-changeindicator.service";
import IconSettings from "@salesforce/design-system-react/components/icon-settings";
import { isSalesforceBuild } from "salesforceBuild";
import CQSubmissionContext from "context/CQSubmissionContext";

const CQTime = ({
  label,
  handleChange,
  path,
  visible,
  uischema,
  data,
  enabled,
  required,
}: any) => {
  const submissionContext = useContext(CQSubmissionContext);
  const [timeValue, setTimeValue] = useState(data);

  const handleInputChange = (evt: any) => {
    if (!evt.target.value.trim().length) {
      handleChange(path, undefined);
      data = ""; // update the data to empty to avoid showing previous value as input doesn't take undefined as input value
      setTimeValue(data);
    } else {
      handleChange(path, evt.target.value);
      setTimeValue(evt.target.value);
    }
    uischema = setEditedValueinOption(
      data,
      submissionContext.submission,
      path,
      uischema
    );
  };

  return (
    <>
      {visible ? (
        <IconSettings iconPath="/assets/icons">
          <div>
            <Input
              className={
                !isSalesforceBuild() &&
                getEditedValueFromOption(
                  uischema,
                  data,
                  path,
                  submissionContext.submission
                )
                  ? "cq-input-edit"
                  : ""
              }
              type="time"
              label={label}
              required={required}
              onInput={handleInputChange}
              value={timeValue}
              disabled={isSalesforceBuild() || !enabled}
            />
          </div>
        </IconSettings>
      ) : (
        ""
      )}
    </>
  );
};

export default withJsonFormsControlProps(CQTime);
